import { useMutation, MutationResult } from '@apollo/client';

import {
  NetworkContactRequestsMutation,
  NetworkRequestResponseUpdateCache,
  ShowErrorParams,
} from '../types';
import NETWORK_CONTACT_REQUEST_MUTATION from '../graphql/NetworkContactRequest.graphql';

type UseNetworkRequestMutationProps = {
  update: NetworkRequestResponseUpdateCache;
  showError: (params: ShowErrorParams) => void;
};

type UseNetworkRequestMutationResponse = [
  (id: string, hasPhoto?: boolean) => void,
  MutationResult<NetworkContactRequestsMutation>
];

const useNetworkRequestMutation = ({
  update = () => {},
  showError,
}: UseNetworkRequestMutationProps): UseNetworkRequestMutationResponse => {
  const [
    executeNetworkRequest,
    response,
  ] = useMutation<NetworkContactRequestsMutation>(
    NETWORK_CONTACT_REQUEST_MUTATION,
    {
      optimisticResponse: {
        __typename: 'Mutation',
        networkContactRequestsSend: {
          error: null,
          __typename: 'CompanyFollow',
        },
      },

      onError: (error) =>
        showError({
          message: 'EP_EMPLOYEES_FEEDBACK_ERROR',
          error,
        }),
    }
  );

  const executeNetworkRequestById = (id: string, hasPhoto?: boolean) => {
    executeNetworkRequest({
      variables: {
        input: {
          recipientId: id,
        },
      },
      update: (data, cache) => update(data, cache, id, hasPhoto),
    });
  };

  return [executeNetworkRequestById, response];
};

export { useNetworkRequestMutation };
